import Router from './Router';

// eslint-disable-next-line import/prefer-default-export
export { Router };
